const VisualizationChartType = Object.freeze({
  HEATMAP: 'heatmap',
  LINE_CHART: 'lineChart',
  STACKED_COLUMN_CHART: 'stackedColumnChart',
  TOPIC_COMPARISON: 'topicComparison',
  BUBBLE_CHART: 'bubbleChart'
})
export default VisualizationChartType
export type VisualizationChartTypeStrings = typeof VisualizationChartType[keyof typeof VisualizationChartType]
// RESERVE BELOW
